import {Component, OnInit} from '@angular/core';
import {TimelineStep, TimelineStepStatus} from '../../common/timeline-progress-bar/timeline.step.model';
import {Keys, StorageService} from '../../service/storage.service';
import {Router} from '@angular/router';
import {UserInteractor} from '../../interactors/user.interactor';
import {UserAddressInteractor} from '../../interactors/user-address.interactor';

@Component({
  selector: 'app-lender-registration-progress-bar',
  templateUrl: './lender-registration-progress-bar.component.html',
  styleUrls: ['./lender-registration-progress-bar.component.css']
})
export class LenderRegistrationProgressBarComponent implements OnInit {

  public steps: TimelineStep[];
  constructor(private storageService: StorageService, private router: Router, private userInteractor: UserInteractor,
              private userAddressInteractor:  UserAddressInteractor) {
  }

  async ngOnInit(): Promise<void> {
    this.steps = [];
    this.populateSteps();
  }
  private async populateSteps(): Promise<void> {
    const user = this.storageService.getItem(Keys.PROFILE_ID) && await this.userInteractor.get();
    const panVerification = new TimelineStep();
    panVerification.description = 'PAN Verification';
    panVerification.url = '/invest/pan-verification';
    if (!!this.storageService.getItem(Keys.PAN_VERIFIED)) {
      panVerification.isClickable = true;
      panVerification.status = TimelineStepStatus.COMPLETE;
    }
    this.steps.push(panVerification);

    const phoneVerification = new TimelineStep();
    phoneVerification.description = 'Phone Verification';
    phoneVerification.url = '/invest/phone-verification';
    if (!!this.storageService.getItem(Keys.IS_OTP_VERIFIED)) {
      phoneVerification.isClickable = true;
      phoneVerification.status = TimelineStepStatus.COMPLETE;
    }
    this.steps.push(phoneVerification);

    const emailVerification = new TimelineStep();
    emailVerification.description = 'Email Verification';
    emailVerification.url = '/invest/email-verification';
    if (user && user.email) {
      emailVerification.isClickable = true;
      emailVerification.status = TimelineStepStatus.COMPLETE;
    }
    this.steps.push(emailVerification);

    const personalInfo = new TimelineStep();
    personalInfo.description = 'Personal Info';
    personalInfo.url = '/lenderpersonalinfo';
    if (user && user.gender && user.dob && user.addresses && user.addresses.length > 0) {
      personalInfo.isClickable = true;
      personalInfo.status = TimelineStepStatus.COMPLETE;
    }
    this.steps.push(personalInfo);

    const residenceInfo = new TimelineStep();
    residenceInfo.description = 'Proof of residence';
    residenceInfo.url = '/invest/residence-info';
    let residenceProof = false;
    if (user && user.addresses && user.addresses.length > 0) {
      const address = await this.userAddressInteractor.get(user.addresses[0]);
      residenceProof = address && address.proofs && address.proofs.length > 0;
    }
    if (residenceProof) {
      residenceInfo.isClickable = true;
      residenceInfo.status = TimelineStepStatus.COMPLETE;
    }
    this.steps.push(residenceInfo);

    const bankDetails = new TimelineStep();
    bankDetails.description = 'Bank details';
    bankDetails.url = '/lenderbankdetails';
    if (!!this.storageService.getItem(Keys.LENDER_BANK_INFO)) {
      bankDetails.isClickable = true;
      bankDetails.status = TimelineStepStatus.COMPLETE;
    }
    this.steps.push(bankDetails);

    const lenderNominee = new  TimelineStep();
    lenderNominee.description = 'Lender Nominee';
    lenderNominee.url = '/invest/lender-nominee';
    if (!!this.storageService.getItem(Keys.LENDER_NOMINEE)) {
      lenderNominee.isClickable = true;
      lenderNominee.status = TimelineStepStatus.COMPLETE;
    }
    this.steps.push(lenderNominee);

    const investmentPreferences = new  TimelineStep();
    investmentPreferences.description = 'Investment Preferences';
    investmentPreferences.url = '/invest/investment-preferences';
    if (!!this.storageService.getItem(Keys.INVESTMENT_PREFERENCES)) {
      investmentPreferences.isClickable = true;
      investmentPreferences.status = TimelineStepStatus.COMPLETE;
    }
    this.steps.push(investmentPreferences);

    const uploadDocuments = new TimelineStep();
    uploadDocuments.description = 'Upload documents';
    uploadDocuments.url = '/lenderuploaddocuments';
    if (!!this.storageService.getItem(Keys.UPLOAD_DOCUMENTS)) {
      uploadDocuments.isClickable = true;
      uploadDocuments.status = TimelineStepStatus.COMPLETE;
    }
    this.steps.push(uploadDocuments);

    const summary = new TimelineStep();
    summary.description = 'Investment Summary';
    summary.url = '/lendersummary';
    if (!!this.storageService.getItem(Keys.UPLOAD_DOCUMENTS)) {
      summary.isClickable = true;
      summary.status = TimelineStepStatus.COMPLETE;
    }
    this.steps.push(summary);

    this.selectActiveStep();
  }

  private selectActiveStep() {
    for (let i = 0; i < this.steps.length; i++) {
      if (this.steps[i].status !== TimelineStepStatus.COMPLETE) {
        this.steps[i].status = TimelineStepStatus.ACTIVE;
        break;
      }
    }
  }

  navigate(step: TimelineStep) {
    this.router.navigate([step.url]);
  }
}
